import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  modalHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
    fontSize: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      gap: theme.spacing(2),
    },
  },
  modalDescription: {
    textAlign: "left",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    margin: theme.spacing(4, 0),
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
  submitButton: {
    width: 150,
    margin: "0 auto",
  },
  footerText: {
    fontSize: "0.8rem",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  textField: {
    "& .MuiInputBase-root": {
      padding: theme.spacing(4, 2),
    },
  },
  buttons: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "center",
    margin: theme.spacing(4, 0),
  },
}));
